import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ModalErrorMessageComponent } from './modal-error-message/modal-error-message.component';
import { ModalInfoMessageComponent } from './modal-info-message/modal-info-message.component';
import { ModalSuccessMessageComponent } from './modal-success-message/modal-success-message.component';
import { ModalWarningMessageComponent } from './modal-warning-message/modal-warning-message.component';

@NgModule({
  imports: [CommonModule],
  declarations: [
    ModalErrorMessageComponent,
    ModalInfoMessageComponent,
    ModalSuccessMessageComponent,
    ModalWarningMessageComponent
  ],
  exports: [
    ModalErrorMessageComponent,
    ModalInfoMessageComponent,
    ModalSuccessMessageComponent,
    ModalWarningMessageComponent
  ]
})
export class SharedLayoutModule {}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/layout/shared-layout.module.ts